import { Skeleton } from '@/components/ui/skeleton'
import { useEvents } from '../hooks/useEvents'
import { EventCard } from '../components/EventCard'

export function EventsPage() {
  const { events, loading, error } = useEvents()

  return (
    <div className="container mx-auto px-4 py-12 space-y-8">
      <div>
        <h1 className="text-4xl font-bold">Upcoming Events</h1>
        <p className="mt-2 text-muted-foreground">Browse and get tickets for our latest events.</p>
      </div>

      {error && <p className="text-sm text-destructive">{error}</p>}

      {loading ? (
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={i} className="h-72 w-full rounded-xl" />
          ))}
        </div>
      ) : events.length === 0 ? (
        <div className="py-20 text-center">
          <p className="text-muted-foreground">No upcoming events at this time. Check back soon!</p>
        </div>
      ) : (
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {events.map((event) => (
            <EventCard key={event.id} event={event} />
          ))}
        </div>
      )}
    </div>
  )
}
